export class CopyToClipboardClass {
    constructor() {
        this.copyBtn = document.getElementById('copyLinkBtn');
        this.lightbox = document.querySelector('[data-lightbox-dc-window="shareWithColleaguesInfo"]')
        if (!this.lightbox) {
            return;
        }
        this.closeBtn = this.lightbox.querySelector('[data-lightbox-dc-close]');

        this.init();
    }

    init() {
        this.addEventListeners()
    }

    addEventListeners() {
        this.copyBtn.addEventListener('click', () => {
            this.copyShareLink()
        })

        this.closeBtn.addEventListener('click', () => {
            this.copyBtn.classList.remove('is-disabled')
        })
    }

    copyShareLink() {
        let copyText = this.copyBtn.dataset.jobsPostingUrl
        navigator.clipboard.writeText(copyText);
        this.copyBtn.classList.add('is-disabled');
    }

}

document.addEventListener('DOMContentLoaded', function () {
    new CopyToClipboardClass();
});
